module.exports = __webpack_public_path__ + "img/reset_appliance_step_1.fd01afdf.png";